export enum ROLES {
  ADMINISTRATOR = "Administrator",
  ORGANIZATION_ADMINISTRATOR = "OrganizationAdministrator",
  PROJECT_MANAGER = "ProjectManager",
  SPECIALIST = "Specialist",
  READONLY = "ReadOnly",
}
